import { getDataMapper, mapField } from "@/shared";

export const mapInventoryPaybacksFiltersToServer = getDataMapper(
    {
        point_id: mapField("pointId", Number),
        category_id: mapField("categoryId", Number),
        payback: mapField("payback", Boolean),
    },
    { shouldAvoidNull: true }
);
